import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  width: 178px;

  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const ImageContainer = styled.div`
  display: flex;
  position: relative;

  height: 90px;
  width: 100%;
`;

export const ProdutoInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing[1]}px;
`;

export const ProdutoDescricao = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const TextoPromocional = styled.p`
  text-decoration-line: line-through;
  color: ${({ theme }) => theme.colors.neutral.neutral_alpha[11]};
  font-weight: ${({ theme }) => theme.typography.font.weight.medium};
`;

export const ContainterPrecoComDescont = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;

export const EtiquetaContainer = styled.div`
  display: flex;
  flex: 1;
`;
